import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import 'react-accessible-accordion/dist/fancy-example.css';
import { Modal } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { connect, useDispatch } from "react-redux";
import Select from "react-select";
import { Col, Input, Row, Table } from "reactstrap";
import swal from "sweetalert";
import Swal from "sweetalert2";
import "../../../css/settings.scss";
import { logout } from "../../../store/actions/AuthActions";
import { api } from "../../../utils/api";
import { exportPageSize, shownItem, withdrawNetworkList } from "../../../utils/config";
import { digitFormat, downloadExcel } from "../../../utils/function";
import { translate } from "../../../utils/translate";
import LoadingV3 from "../../components/Loading/LoadingV3";
import InfoBox from "../Common/InfoBox";
import NotFound from "../Common/NotFound";
import customSelectStyles from '../SelectStyle';

const { RangePicker } = DatePicker;

const Withdrawal = (props) => {
    const dispatch = useDispatch();
    const statusList = [
        { label: translate(props.lang, "All"), value: "" },
        { label: translate(props.lang, "wallet_pending"), value: "Pending" },
        { label: translate(props.lang, "wallet_approved"), value: "Approved" },
        { label: translate(props.lang, "wallet_rejected"), value: "Rejected" }
    ]
    const [totalResultCount, setTotalResultCount] = useState(0);
    const [productPerpage, setProductPerpage] = useState(10);
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [groupEmail, setGroupEmail] = useState('');
    const [result, setResult] = useState([]);
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('');
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [modal, setModal] = useState(false);
    const [remarkModal, setRemarkModal] = useState(false);
    const [loadingAction, setLoadingAction] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [firstLoad, setFirstLoad] = useState(true);
    const [chain, setChain] = useState("");
    const [selectedRequest, setSelectedRequest] = useState({
        id: '',
        action: '',
        walletAddress: '',
        txnHash: ''
    });
    const [remark, setRemark] = useState('');
    const [withdrawInfo, setWithdrawInfo] = useState(null);
    const [withdrawSummary, setWithdrawSummary] = useState({
        total_crm_withdraw: 0,
    });
    const timerRef = useRef(null);

    const changePage = (event) => {
        setPageNumber(event.selected + 1);
        getTransactionList(event.selected + 1);
    }

    useEffect(() => {
        if (firstLoad) {
            getTransactionList();
            setFirstLoad(false);
        }
    }, [firstLoad]);

    useEffect(() => {
        if (!firstLoad) {
            let newData = { ...withdrawSummary };
            newData.total_crm_withdraw = 0;
            setWithdrawSummary(newData);
            setPageNumber(1);
            getTransactionList(1);
        }
    }, [props.lang, from, to, productPerpage, email, status, groupEmail, chain]);

    const handleTimeChange = (e) => {
        const formattedFromDate = e ? dayjs(e[0]).format("YYYY-MM-DD") : '';
        const formattedToDate = e ? dayjs(e[1]).format("YYYY-MM-DD") : '';
        setFrom(formattedFromDate);
        setTo(formattedToDate);
    };

    const getTransactionList = (page = pageNumber) => {
        setLoading(true);
        let url = api.get_orders + `?page=${page}&types=FIAT_WITHDRAW,CRYPTO_WITHDRAW`;

        if (from && to) {
            url += `&date_start=${from}&date_end=${to}`
        }
        if (status) {
            url += `&status=${status}`
        }
        if (productPerpage) {
            url += `&limit=${productPerpage}`
        }
        if (email) {
            url += `&email=${email}`
        }
        if (groupEmail) {
            url += `&group_email=${groupEmail}`
        }
        if (chain) {
            url += `&chain=${chain}`
        }
        fetch(url, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang,
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
                if (responseJson.status === "success") {
                    if (responseJson.data.statistic) {
                        setWithdrawSummary(responseJson.data.statistic)
                    }
                    setResult(responseJson.data.results);
                    var pageCount = Math.ceil(responseJson.data.total_results / productPerpage)
                    setPageCount(pageCount);
                    setTotalResultCount(responseJson.data.total_results)
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    console.log("error", responseJson.message);
                }

            }).catch(error => {
                console.error("error", error);
            });
    }

    const getData = (id) => {
        fetch(api.get_order_details + `/${id}`, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang,
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                if (responseJson.status === "success") {
                    setWithdrawInfo(responseJson.data)
                    setModal(true);
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    swal(translate(props.lang, "Error"), responseJson.message, "error");
                }
            }).catch(error => {
                console.error("error", error);
            });


    }

    const openRemarkModal = (id, action) => {
        setSelectedRequest({ id: id, action: action });
        setRemarkModal(true);
    }

    const closeRemarkModal = () => {
        setRemark('');
        setSelectedRequest({ id: '', action: '' });
        setRemarkModal(false);
    }

    const submitForm = () => {
        Swal.fire({
            title: translate(props.lang, `Attention`),
            text: translate(props.lang, `Confirm ${selectedRequest.action} this request?`),
            icon: "warning",
            showCancelButton: true,
            cancelButtonColor: "#A4B6E1",
            confirmButtonText: translate(props.lang, 'Ok'), // Add the translation for 'OK' here
            cancelButtonText: translate(props.lang, 'Cancel'), // Add the translation for 'Cancel' here
            customClass: {
                // Add the custom CSS class to the Swal dialog
                popup: 'swal2-popup',
                actions: 'swal2-actions'
            }
        }).then(function (result) {
            if (result.isConfirmed) {
                setLoadingAction(true);
                let data = {
                    status: selectedRequest.action === "approve" ? "Approved" : "Rejected",
                    remark: remark
                }
                fetch(api.withdraw_action + `/${selectedRequest.id}`, {
                    method: "PUT",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        "Accept-Language": props.lang,
                        "Authorization": "Bearer " + props.auth.auth.access_token
                    }),
                    body: JSON.stringify(data)
                })
                    .then(response => response.json())
                    .then(responseJson => {
                        setLoadingAction(false);
                        if (responseJson.status === "success") {
                            getTransactionList();
                            closeRemarkModal();
                            swal(translate(props.lang, "Success"), responseJson.message, "success");
                        } else {
                            if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                                dispatch(logout(props.history, 'login'));
                            }
                            swal(translate(props.lang, "Error"), responseJson.message, "error");
                        }

                    }).catch(error => {
                        console.error("error", error);
                    });
            }
        });
    }

    const formatData = (data) => {
        let newData = [];
        data.forEach(entry => {
            let formattedData = {
                "Doc No": entry.order_number,
                "Submit Date": entry.date_added,
                "Name": entry.customer_name,
                "Email": entry.customer_email,
                "Submit Amount": entry.submit_amount ? Number(entry.submit_amount).toLocaleString('en-US', digitFormat) : 0,
                "Withdraw Type": entry.type_text,
                "Fee": entry.fee ? Number(entry.fee).toLocaleString('en-US', digitFormat) : 0,
                "Fee in Fiat": entry.fee_in_fiat ? Number(entry.fee_in_fiat).toLocaleString('en-US', digitFormat) : 0,
                "Rate": entry.exchange_rate ? Number(entry.exchange_rate).toLocaleString('en-US', digitFormat) : "-",
                "Currency": entry.currency ? entry.currency : "-",
                "Receive Amount": entry.receive_amount ? Number(entry.receive_amount).toLocaleString('en-US', digitFormat) : "-",
                "Status": entry.status ? entry.status : "-",
                "Remark": entry.remark ? entry.remark : '-',
                "Process Date": entry.date_modified ? entry.date_modified : "-"
            };
            newData.push(formattedData);
        });
        return newData;
    }

    const exportExcel = () => {
        const totalPagesCount = Math.ceil(totalResultCount / exportPageSize);
        let processData = [];
        let totaldata = 0;
        if (totalPagesCount > 0) {
            setLoadingExcel(true);
            for (let pageCount = 1; pageCount <= totalPagesCount; pageCount++) {
                let url = api.get_orders + `?page=${pageCount}&types=FIAT_WITHDRAW,CRYPTO_WITHDRAW&limit=${exportPageSize}`;

                if (from && to) {
                    url += `&date_start=${from}&date_end=${to}`
                }
                if (status) {
                    url += `&status=${status}`
                }
                if (email) {
                    url += `&email=${email}`
                }
                if (groupEmail) {
                    url += `&group_email=${groupEmail}`
                }
                if (chain) {
                    url += `&chain=${chain}`
                }

                fetch(url, {
                    method: "GET",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        "Accept-Language": props.lang,
                        "Authorization": "Bearer " + props.auth.auth.access_token
                    }),
                })
                    .then(response => response.json())
                    .then(responseJson => {
                        if (responseJson.status === "success") {
                            totaldata = responseJson.data.total_results;
                            processData = processData.concat(formatData(responseJson.data.results));
                        } else {
                            if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                                dispatch(logout(props.history, 'login'));
                            }
                            swal(translate(props.lang, "Error"), responseJson.message, "error");
                        }
                        if (processData.length === totaldata) {
                            downloadExcel(processData, 'withdrawal')
                            setLoadingExcel(false)
                        }
                    }).catch(error => {
                        console.error("error", error);
                    });

            }
        } else {
            swal(translate(props.lang, "Error"), translate(props.lang, "No data to export"), "error");
        }

    }

    const handleAddFormChange = (event) => {
        event.preventDefault();
        const fieldName = event.target.getAttribute('name');
        const fieldValue = event.target.value;
        const newFormData = { ...selectedRequest };
        newFormData[fieldName] = fieldValue;
        setSelectedRequest(newFormData);
    }

    return (
        <>
            <div className='pb-5 wallet'>
                <Row className="mx-0 px-0 mt-3 mt-md-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="whiteContainer px-md-4 py-md-4 p-2">
                            <div className="infoContainer">
                                <div className="px-md-3 py-md-3 px-2 py-4">
                                    <Row className="mx-0 px-0">
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <span className="infoTitle">{translate(props.lang, "CRM Withdrawal")}</span>
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "Personal Withdraw")}
                                                boxValue={withdrawSummary && withdrawSummary.total_crm_withdraw && !groupEmail ? Number(withdrawSummary.total_crm_withdraw).toLocaleString('en-US', digitFormat) : 0}
                                                loading={false}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12} className="mt-3">
                                            <InfoBox
                                                boxLabel={translate(props.lang, "Group Withdraw")}
                                                boxValue={withdrawSummary && withdrawSummary.total_crm_withdraw && groupEmail ? Number(withdrawSummary.total_crm_withdraw).toLocaleString('en-US', digitFormat) : 0}
                                                loading={false}
                                            />
                                        </Col>

                                    </Row>
                                </div>
                            </div>
                            <div className="tableContainer">
                                <Row className="align-items-start">
                                    <Col lg={4} md={4} sm={12} xs={12} className="mt-3">
                                        <div className="groupLabel-input">
                                            <div className="input-group">
                                                <Input
                                                    type="text"
                                                    placeholder={translate(props.lang, "Personal (Search By Email)")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => setEmail(e.target.value)}
                                                    value={email}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mt-3">
                                        <div className="groupLabel-input">
                                            <div className="input-group">
                                                <Input
                                                    type="text"
                                                    placeholder={translate(props.lang, "Group (Search By Email)")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => setGroupEmail(e.target.value ? e.target.value : '')}
                                                    value={groupEmail}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mt-3">
                                        <div className="">
                                            <RangePicker
                                                className="w-100 input-transparent"
                                                placeholder={[
                                                    translate(props.lang, "From"),
                                                    translate(props.lang, "To"),
                                                ]}

                                                onChange={(e) => handleTimeChange(e)}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mt-3">
                                        <div className="input-group-select select-placeholder-center">
                                            <div className="d-flex align-items-center">
                                                <Select
                                                    options={
                                                        statusList.length > 0 ? statusList.map((item, i) => ({ value: item.value, label: item.label })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                    }
                                                    placeholder={translate(props.lang, "All")}
                                                    className="input-transparent w-100 text-capitalize"
                                                    styles={customSelectStyles}
                                                    value={statusList && statusList.find(option => option.value === status)}
                                                    name="status"
                                                    onChange={(e) => setStatus(e.value)}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mt-3">
                                        <div className="input-group-select select-placeholder-center">
                                            <div className="d-flex align-items-center">
                                                <Select
                                                    options={
                                                        withdrawNetworkList.length > 0 ? withdrawNetworkList.map((item, i) => ({ key: i, value: item.value, label: item.label })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                    }
                                                    placeholder={translate(props.lang, "Select Network")}
                                                    className="input-transparent w-100 text-capitalize"
                                                    styles={customSelectStyles}
                                                    value={chain && withdrawNetworkList.find(option => option.value === chain)}
                                                    name="chain"
                                                    isClearable
                                                    onChange={(e) => setChain(e ? e.value : '')}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mt-3">
                                        <div className="input-group-select select-placeholder-center">
                                            <Select
                                                options={
                                                    shownItem.length > 0 ? shownItem.map((item, i) => ({ key: i, value: item.value, label: item.label })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                }
                                                placeholder={translate(props.lang, "Result Per Page")}
                                                className="input-transparent w-100 text-capitalize"
                                                styles={customSelectStyles}
                                                value={shownItem && shownItem.find(option => option.value === productPerpage)}
                                                name="productPerpage"
                                                onChange={(e) => setProductPerpage(e.value)}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mt-3">
                                        <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => exportExcel()} disabled={loadingExcel}>
                                            <span className={`btnText`}>{loadingExcel ? <FaSpinner className="fa-spin" /> : translate(props.lang, "Download Excel")}</span>
                                        </button>
                                    </Col>
                                </Row>
                                <Table responsive className="w-100 table-list mt-4 text-center position-relative">
                                    <thead>
                                        <tr>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Doc No")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Submit Date")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Name")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Email")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Submit Amount")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Withdraw Type")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Fee")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Fee In Fiat")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Rate")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Receive Currency")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Receive Amount")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Status")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Remark")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Process Date")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={14}>
                                                    <LoadingV3 theme='light' />
                                                </td>
                                            </tr>
                                        ) : (
                                            result.length > 0 ? (
                                                result.map((item, i) => (
                                                    <tr role="row" className={`${i % 2 === 0 ? 'even' : 'odd'}`} key={i}>
                                                        <td className={`font-weight-500 font-16 text-center text-black lh-base`}>{item.order_number ? item.order_number : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center lh-base`}>{item.date_added ? item.date_added : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.customer_name ? item.customer_name : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.customer_email ? item.customer_email : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.submit_amount ? Number(item.submit_amount).toLocaleString('en-US', digitFormat) : 0}</td>
                                                        <td className={`font-weight-500 font-16 text-center text-capitalize`}>{item.type_text ? item.type_text : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{Number(item.fee).toLocaleString('en-US', digitFormat)}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.fee_in_fiat ? Number(item.fee_in_fiat).toLocaleString('en-US', digitFormat) : 0}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{(item.exchange_rate ? (Number(item.exchange_rate)).toLocaleString('en-US', digitFormat) : "-")}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.currency ? item.currency : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.receive_amount ? Number(item.receive_amount).toLocaleString('en-US', digitFormat) : 0}</td>
                                                        <td className={`font-weight-500 font-16 text-center status ${item.status.toLowerCase()}`}>{translate(props.lang, "wallet_" + item.status.toLowerCase())}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.remark ? item.remark : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.date_modified ? item.date_modified : "-"}</td>
                                                        <td className={`font-weight-500 font-16 text-white`}>
                                                            <div className="d-flex justify-content-start">
                                                                <button className="primary-btn py-2 text-center px-4" onClick={() => { getData(item.order_id) }}>
                                                                    <span className={`btnText`}>{translate(props.lang, "View")}</span>
                                                                </button>
                                                                {item.status !== "Rejected" && item.status !== "Approved" && (
                                                                    <>
                                                                        <button className="green-btn py-2 text-center mx-auto px-4 ms-2" onClick={() => { openRemarkModal(item.order_id, "approve") }}>
                                                                            <span className={`btnText`}>{translate(props.lang, "Approve")}</span>
                                                                        </button>
                                                                        <button className="deleteBtn py-2 text-center mx-auto px-4 ms-2" onClick={() => { openRemarkModal(item.order_id, "reject") }}>
                                                                            <span className={`btnText`}>{translate(props.lang, "Reject")}</span>
                                                                        </button>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </td>

                                                    </tr>
                                                ))
                                            ) : (
                                                <tr role="row" className={`even`}>
                                                    <td colSpan={14}>
                                                        <NotFound />
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="pt-4">
                                {!loading && result.length > 0 ? (
                                    <div className="my-3">
                                        <ReactPaginate
                                            previousLabel={"<"}
                                            nextLabel={">"}
                                            pageCount={pageCount}
                                            forcePage={pageNumber - 1}
                                            onPageChange={changePage}
                                            containerClassName={"pagination font-weight-400 font-16 text-uppercase text-grey-2"}
                                            previousLinkClassName={"pagination__previouslink pagination-arrow text-black"}
                                            nextLinkClassName={"pagination__nextlink pagination-arrow text-black"}
                                            disabledClassName={"pagination__link--disabled text-muted"}
                                            activeClassName={"pagination__link--active text-black"}
                                            marginPagesDisplayed={window.innerWidth > 667 ? 3 : 1}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <Modal className="fade bgImgModal" show={modal} centered>
                <Modal.Header className="border-0 pt-4 pb-2">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => setModal(false)} >
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0 px-3">
                    <div className='modalBody'>
                        <div>
                            <div className="text-center mb-5">
                                <span className="font-weight-600 font-30 text-black">{translate(props.lang, "Wallet Withdrawal Details")}</span>
                            </div>
                            {withdrawInfo ? (
                                <Row className="justify-content-center justify-content-md-start mx-4">
                                    <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-0">
                                        <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Doc No")}</span>
                                        <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{withdrawInfo ? withdrawInfo.order_number ? withdrawInfo.order_number : '-' : '-'}</span>
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">
                                        <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Submit Date")}</span>
                                        <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{withdrawInfo ? withdrawInfo.date_added ? withdrawInfo.date_added : '-' : '-'}</span>
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">
                                        <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Name")}</span>
                                        <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{withdrawInfo ? withdrawInfo.customer_name ? withdrawInfo.customer_name : '-' : '-'}</span>
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">
                                        <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Receive Amount")}</span>
                                        <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{withdrawInfo ? withdrawInfo.receive_amount ? Number(withdrawInfo.receive_amount).toLocaleString() : '-' : '-'}</span>
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">
                                        <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Receive Currency")}</span>
                                        <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{withdrawInfo ? withdrawInfo.currency ? withdrawInfo.currency : '-' : '-'}</span>
                                    </Col>
                                    {withdrawInfo ? withdrawInfo.type === 'FIAT_WITHDRAW' ? (
                                        <>
                                            <div className="mt-5 text-center">
                                                <span className="font-weight-600 font-26 text-black">{translate(props.lang, "Fiat Section")}</span>
                                            </div>
                                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">
                                                <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Bank Name")}</span>
                                                <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{withdrawInfo ? withdrawInfo.payment_method && withdrawInfo.payment_method.bank_name ? withdrawInfo.payment_method.bank_name : '-' : '-'}</span>
                                            </Col>
                                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">
                                                <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Bank Account Name")}</span>
                                                <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{withdrawInfo ? withdrawInfo.payment_method && withdrawInfo.payment_method.account_holder_name ? withdrawInfo.payment_method.account_holder_name : '-' : '-'}</span>
                                            </Col>
                                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">
                                                <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Bank Account No.")}</span>
                                                <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{withdrawInfo ? withdrawInfo.payment_method && withdrawInfo.payment_method.account_number ? withdrawInfo.payment_method.account_number : '-' : '-'}</span>
                                            </Col>
                                        </>
                                    ) : (
                                        <>
                                            <div className="mt-5 text-center">
                                                <span className="font-weight-600 font-26 text-black">{translate(props.lang, "Crypto Section")}</span>
                                            </div>
                                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">
                                                <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Chain Type")}</span>
                                                <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{withdrawInfo ? withdrawInfo.payment_method && withdrawInfo.payment_method.chain ? withdrawInfo.payment_method.chain : '-' : '-'}</span>
                                            </Col>
                                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">
                                                <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Wallet Address")}</span>
                                                <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{withdrawInfo ? withdrawInfo.payment_method && withdrawInfo.payment_method.address ? withdrawInfo.payment_method.address : '-' : '-'}</span>
                                            </Col>
                                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">
                                                <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Process Date")}</span>
                                                <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{withdrawInfo ? withdrawInfo.date_modified ? withdrawInfo.date_modified : '-' : "-"}</span>
                                            </Col>

                                        </>
                                    ) : null}
                                    <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">
                                        <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Status")}</span>
                                        <span className={`font-weight-600 font-18 d-block mt-2 status ${withdrawInfo.status.toLowerCase()}`}>{withdrawInfo ? translate(props.lang, "wallet_" + withdrawInfo.status.toLowerCase()) : "-"}</span>
                                    </Col>

                                    <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">
                                        <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Remark")}</span>
                                        <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{withdrawInfo ? withdrawInfo.remark ? withdrawInfo.remark : '-' : "-"}</span>
                                    </Col>
                                    {withdrawInfo && withdrawInfo.withdrawal_remark && withdrawInfo.withdrawal_remark.map((item, i) => (
                                        <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4" key={i}>
                                            <Row className="px-0 mx-0">
                                                <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                                                    <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Txn Hash")}</span>
                                                </Col>
                                                <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                                                    <span className={`font-weight-600 font-18 text-black d-block mt-2 break-all-word`}><a className="text-black" href={item.transaction_url} target="_blank">{item.transaction_hash}</a></span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    ))}
                                </Row>
                            ) : null}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal className="fade bgImgModal" show={remarkModal} centered>
                <Modal.Header className="border-0 pt-4 pb-2">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => closeRemarkModal()}>
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0 px-3">
                    <div className='modalBody'>
                        <div className="px-0 px-md-4">
                            <Row className="justify-content-start px-0 mx-0">
                                <Col lg={12} md={12} sm={12} xs={12} className="my-3">
                                    <div className="text-center mb-3">
                                        <span className="font-weight-600 font-30 text-black">{translate(props.lang, "Remark")}</span>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-3">
                                    <span className="font-16 font-weight-600 text-grey-2">{translate(props.lang, "Remark")}</span>
                                    <div className={`groupLabel-input mt-2 mb-1`}>
                                        <div className={`input-group`}>
                                            <Input
                                                type="text"
                                                placeholder={translate(props.lang, "Enter Remark")}
                                                className="form-control input-transparent py-1 px-3"
                                                name="remark"
                                                value={remark}
                                                onChange={e => setRemark(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={12} md={12} sm={12} xs={12} className="mt-4">
                                    <button className="primary-btn px-4 py-1 text-center mx-auto w-100" onClick={() => submitForm()} disabled={loadingAction}>
                                        <span className={`font-weight-600 font-20 line-height-30 text-white`}>{loadingAction ? <FaSpinner className="fa-spin" /> : translate(props.lang, "Submit")}</span>
                                    </button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(Withdrawal);